// Logica pura de la lista de plantas: sin React, sin reloj, con test al lado.
//
// El portal es de una empresa que trabaja para VARIAS plantas: ninguna
// funcion de aca puede devolver "la planta" ni asumir que hay una sola. La
// planta es siempre un dato y viaja con su id.
import type { SiteAccess, AdminSessionContext } from "../sites/port.js";

/** Los cuatro estados que la pantalla sabe pintar. Sin datos inventados. */
export type EstadoDePlantas =
  | { estado: "cargando" }
  /** La sesion no autoriza acceso al portal. */
  | { estado: "denegado" }
  /** Hubo un error al consultarlas: se puede reintentar. */
  | { estado: "error" }
  /** Respuesta buena. `plantas` vacio es una cuenta sin habilitaciones. */
  | { estado: "listo"; plantas: readonly SiteAccess[] };

/**
 * Orden estable para la lista: por nombre y, a igual nombre, por id. Sin
 * `localeCompare` con locale del navegador: el orden tiene que ser el mismo
 * en cualquier maquina para que el test lo pueda afirmar.
 */
export function ordenarPlantas(plantas: readonly SiteAccess[]): readonly SiteAccess[] {
  return [...plantas].sort((a, b) => {
    if (a.name !== b.name) return a.name < b.name ? -1 : 1;
    return a.siteId < b.siteId ? -1 : a.siteId > b.siteId ? 1 : 0;
  });
}

/** Del contexto de sesion al estado de pantalla. */
export function estadoDesdeContexto(contexto: AdminSessionContext): EstadoDePlantas {
  return { estado: "listo", plantas: ordenarPlantas(contexto.sites) };
}

/**
 * La misma empresa puede estar habilitada en una planta con mas de un id
 * local de proveedor (una planta puede contratarla por dos vias). La cuenta
 * de plantas es de plantas distintas, no de habilitaciones.
 */
export function cantidadDePlantas(plantas: readonly SiteAccess[]): number {
  return new Set(plantas.map((planta) => planta.siteId)).size;
}
